/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.getFollowState'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  requester: /*#__PURE__*/ l.string({ format: 'did' }),
  target: /*#__PURE__*/ l.string({ format: 'did' }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  requester: /*#__PURE__*/ l.string({ format: 'did' }),
  target: /*#__PURE__*/ l.string({ format: 'did' }),
  state: /*#__PURE__*/ l.string<{
    knownValues: [
      'none',
      'requested',
      'approved',
      'denied',
      'revoked',
      'blocked',
    ]
  }>(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Read the directional protected-access state when the authenticated actor is either the requester or target. This does not read or create a public follow record. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
